<template>
  <v-text-field v-model="query" @input="queryChanged"
    flat
    solo-inverted
    hide-details
    prepend-inner-icon="search"
    label="Search"
    class="hidden-sm-and-down"
  ></v-text-field>
</template>

<script>
export default {
  name: 'Search',
  data() {
    return {
      query: null
    }
  },
  methods: {
    queryChanged() {
      this.$store.commit('FILTER_BY_QUERY', this.query)
    }
  }
}
</script>
